import { render, staticRenderFns } from "./bmi.vue?vue&type=template&id=6e85ff7a&scoped=true&"
import script from "./bmi.vue?vue&type=script&lang=js&"
export * from "./bmi.vue?vue&type=script&lang=js&"
import style0 from "./bmi.vue?vue&type=style&index=0&id=6e85ff7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e85ff7a",
  null
  
)

export default component.exports